module.exports = __webpack_public_path__ + "img/official.9ece1bf2.svg";